import DashboardAdmin from "./components/DashboardAdmin";
import DashboardSaller from "./components/DashboardSaller";
import DashboardConfirmator from "./components/DashboardConfirmator";
import AnnonceDashboard from "../../components/AnnonceDashboard";
import { useAuth } from "../../context/AuthProvider";

export default function Dashboard() {
  const { role } = useAuth();

  return (
    <div className="">
      <AnnonceDashboard />
      {(role === 1 || role === 2) && <DashboardAdmin  />}
      {role === 3 && <DashboardConfirmator  />}
      {role === 0 && <DashboardSaller  />}
      {role === 4 && <div> hello livreur</div>}
    </div>
  );
}
